import { FC, ReactNode } from 'react'

import { useQuery } from '@tanstack/react-query'
import { getRouteApi, notFound } from '@tanstack/react-router'
// eslint-disable-next-line max-len
import { onboardingDocumentDetailsQueryOptions } from '~bank-onboarding-documents/service/onboardingDocumentDetailsQueryOptions'

import { SetupDocumentsViewDetailsContext } from './SetupDocumentsViewDetailsContext'

type SetupDocumentsViewDetailsProviderProps = {
  children: ReactNode
}

export const SetupDocumentsViewDetailsContextProvider: FC<SetupDocumentsViewDetailsProviderProps> = ({
  children
}: SetupDocumentsViewDetailsProviderProps) => {
  const routeApi = getRouteApi('/_app/application/$applicationId/onboarding-documents/$id/details')

  const search = routeApi.useSearch()
  const params = routeApi.useParams()
  const navigate = routeApi.useNavigate()

  const opts = { id: Number(params.id), historyPage: search.historyPage, historySize: search.historySize }
  const onboardingDocumentDetailsQuery = useQuery(onboardingDocumentDetailsQueryOptions(opts))

  if (onboardingDocumentDetailsQuery.isError) throw notFound()
  if (!onboardingDocumentDetailsQuery.data) return null

  const value = {
    data: onboardingDocumentDetailsQuery.data,
    isPending: onboardingDocumentDetailsQuery.isLoading || onboardingDocumentDetailsQuery.isRefetching,
    successFullyLoaded: !!onboardingDocumentDetailsQuery.data,
    invalidate: onboardingDocumentDetailsQuery.refetch,
    search: opts,
    clear: () => navigate({ to: '.', search: undefined, resetScroll: false, replace: true })
  }

  return <SetupDocumentsViewDetailsContext.Provider value={value}>{children}</SetupDocumentsViewDetailsContext.Provider>
}
